// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1757":"ba7f3f0e","8207":"871faa7d"}[chunkId] + ".chunk.css";
};